import { Album } from 'src/app/libs/proto/commUnity_pb';
import { BinaryWriter } from 'google-protobuf';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlbumConversionService{
  constructor(){}

  ToStorage(req: Album) {
    const w = new BinaryWriter();
    Album.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (album: Album, errorConvert: any) => void) {
    try {
      callback( Album.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(album: Album[]) {
    const rets = new Array<Uint8Array | number[]>();

    album.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (album: Album[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Album>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Album.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }


}
